import { render, staticRenderFns } from "./DataStreams.vue?vue&type=template&id=4d8e8857&scoped=true"
import script from "./DataStreams.vue?vue&type=script&lang=js"
export * from "./DataStreams.vue?vue&type=script&lang=js"
import style0 from "./DataStreams.vue?vue&type=style&index=0&id=4d8e8857&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e8857",
  null
  
)

export default component.exports